module.exports = __webpack_public_path__ + "images/video-shooting-91f4c8c6cab5b70cf3e3529afca31207.svg";